import { Injectable } from "@angular/core";
import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";
import { IInterventionDataPromiseLookupService } from "../IInterventionDataPromiseLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class InterventionDataPromiseLookupService
  extends PromiseBlotterLookupService<string, CubiqTS.InterventionEventImpl>
  implements IInterventionDataPromiseLookupService, IBasePrimeDependent
{
  constructor() {
    super();
  }

  abstract getInterventionData(id: string): Promise<CubiqTS.InterventionEventImpl>;
  abstract addDependentPrime(dependentIsPrimed: Promise<boolean>): Promise<boolean>;
  abstract addOrderEntryReference(ref: string): Promise<boolean>;
  abstract removeOrderEntryReference(ref: string): Promise<boolean>;
  abstract hasOrderEntryReference(ref: string): Promise<boolean>;
}
